export const tags = [
    'SOPInstanceUID',
    'SOPClassUID',
    'InstanceNumber',
    'InstanceCreationDate',
    'InstanceCreationTime',
    'ContentTime',
    'LossyImageCompression',
    'LossyImageCompressionRatio',
    'LossyImageCompressionMethod',
    'FrameOfReferenceUID',
    'NumberOfFrames',
    'PixelSpacing',
];
